<template>
	<v-text-field
		ref="field"
		class="body-2"
		:label="label"
		autocomplete="off"
		hide-details
		:readonly="readonly"
		:required="required"
		:disabled="disabled"
		:suffix="suffix"
		:prepend-icon="prependIcon"
		:prepend-inner-icon="prependInnerIcon"
		:loading="loading"
		:rules="allRules"
		:solo="solo"
		:filled="filled"
		:flat="flat"
		:outline="outline"
		:name="name"
		:value="value"
		:validate-on-blur="validateOnBlur"
		@paste.prevent="onPaste"
		@input="onInput"
		@focus="onFocus"
		@blur="onBlur"
		@change="onChange"
	>
		<template v-slot:prepend-inner>
			<slot name="prepend-inner"></slot>
		</template>
		<template v-slot:prepend>
			<slot name="prepend"></slot>
		</template>
		<template v-slot:append>
			<slot name="append"></slot>
		</template>
		<template v-slot:append-outer>
			<slot name="append-outer"></slot>
		</template>
	</v-text-field>
</template>

<script>
	import {toNum, toStr} from '../../js/common'

	export default {
		props: {
			label: String,
			value: [String, Number],
			readonly: Boolean,
			disabled: Boolean,
			required: Boolean,
			loading: Boolean,
			solo: Boolean,
			filled: Boolean,
			outline: Boolean,
			flat: Boolean,
			suffix: String,
			prependIcon: String,
			prependInnerIcon: String,
			name: String,
			align: String,
			rules: Array,
			validateOnBlur: {
				type: Boolean,
				default: false
			},
			digits: {
				type: [String, Number],
				default: 2
			}
		},
		computed: {
			allRules() {
				const rules = this.rules || []

				if (this.required) {
					var rule =
						v => !!v || 'Введите значение'

					rules.push(rule)
				}

				// console.log(rules)

				return rules
			},
		},
		data: () => ({
			debug: false
		}),
		methods: {
			format: function (val) {
				// console.log('format ' + val)

				val = val + ''
			    val = val.replace(/[^0-9+\-.,]/g, '')    // убираемся все не-цифры
			    val = val.replace(/,/g, '.')             // , заменяем на .
			    val = toStr(val, this.digits)
				// console.log(val)
				return val
				// this.$emit('input', val)
			},
			unFormat: function (val) {
				if (this.debug) console.log('unformat ' + val)
				if (this.debug) console.log('formatted:   ' + val)
				if (this.readonly || this.disabled) return val
				if (+val == 0) return ''
				val = val + ''
				val = val.replace(/\s/g, '')
				if (this.debug) console.log('unformatted: ' + val)
				return val
			},
			onPaste: function (event) {
				// console.log('onPaste')
				let val = event.clipboardData.getData('text')
				val = val.trim()
				let delimeter = '\n'
				let arr = val.split(delimeter)
				for (let i = 0; i < arr.length; i++) {
					arr[i] = this.format(arr[i])
				}
				// console.log('arr', arr)
				val = arr.shift()
				// console.log('val', val)
				// console.log('arr', arr)
				this.$emit('change', val)
				if (arr.length) this.$emit('newline', arr.join(delimeter))
			},
			onInput: function (val) {
				if (this.debug) console.log('onInput')
				this.$emit('input', val)
			},
			onChange: function(e) {
				if (this.debug) console.log('onChange')
				e = this.format(e)
				this.$emit('input', e)
				this.$emit('change', e)
			},
			onFocus: function(e) {
				if (this.debug) console.log('onFocus')
				let val = this.unFormat(this.value)
				if (this.debug) console.log(this.value, val)
				this.$emit('input', val)
				this.$emit('focus', val)
				// this.$refs.field.focus()
			},
			onBlur: function() {
				this.$emit('blur')
			},
			focus: function() {
				if (this.debug) console.log('focus')
				setTimeout(() => {
					// this.onFocus()
					this.$refs.field.focus()
				}, 200)
			},
		},
		created() {
			if (this.debug) console.log('created')
			let val = this.format(this.value)
			this.$emit('input', val)
			this.$emit('change', val)
		},
	}
</script>

<style scoped>
	.v-text-field {
		padding-top: 0px;
		margin-top: 0px;
	}
	/deep/ .v-input__slot {
		margin-bottom: 0px;
	}
	/deep/ .v-text-field__slot > input {
		text-align: right;
		padding-bottom: 4px;
	}
	/deep/ .v-text-field__details > .v-messages {
		min-height: 0px;
	}
</style>
